exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HomePage .el-main{position:relative;margin-top:80px}@media screen and (max-width:414px){.HomePage .el-main{margin-top:0}}", ""]);

// exports
